import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import {
  Loader,
  NoBgLoaderWrapper
} from '../../../components/page-loader/styled-components'
import ErrorPopup from '../../../components/error'
import { FullContainer } from '../../../components/form-fields/styled-components'
import { useLoginSamlMutation } from '../../../react-query/authentication/mutations/use-login-saml-mutation'

const SamlLogin = () => {
  const location = useLocation()

  const credentials = useMemo(() => {
    const queryParams = new URLSearchParams(location.search)
    const rawToken = queryParams.get('oauthToken')
    try {
      return rawToken ? JSON.parse(rawToken) : null
    } catch (e) {
      return null
    }
  }, [location.search])

  const { mutateAsync, isLoading, error } = useLoginSamlMutation()

  useEffect(() => {
    if (credentials) {
      mutateAsync({ credentials })
    }
  }, [credentials, mutateAsync])

  return (
    <FullContainer>
      {isLoading && !error && credentials ? (
        <NoBgLoaderWrapper className="noscroller">
          <Loader className="loader" />
        </NoBgLoaderWrapper>
      ) : (
        <ErrorPopup error={'oauthToken is missing!'} />
      )}
    </FullContainer>
  )
}

export default SamlLogin
